import posthog from 'posthog-js';

import { MeResponse } from './accounts_service';

export const getPosthogDistinctId = () =>
  posthog.__loaded ? posthog.get_distinct_id() : null;

export const posthogIdentify = (data: MeResponse): void => {
  if (posthog.__loaded && !posthog._isIdentified() && data) {
    // identify user and set group in posthog
    posthog.identify(data.member.id.toString(10), {
      email: data.email,
      name: data.firstName,
      first_name: data.firstName,
      last_name: data.lastName,
      plan_name: data.planName,
      billing_interval: data.billingPeriod,
      team: data.team.id.toString(10),
      disable_marketing_email: data.member.id % 100 < 2,
    });
    posthog.group('team', data.team.id.toString(10), {
      name: data.team.name,
      plan_name: data.planName,
      billing_interval: data.billingPeriod,
    });
  }
};
